export default class LegacyChannelInfo {
  public address = '';
  public identifier: string;
  public username: string;
  public password: string;
}



// WEBPACK FOOTER //
// ./src/modules/organization/models/LegacyChannelInfo.ts